export enum EnvironmentEnum {
  SANDBOX = 1,
  PRODUCTION = 2,
}
